import AjaxUtils from './ajaxUtils';

export const getUserActivity = async () => {
  return AjaxUtils.get('/api/v1/user-activity/activity');
};

export const submitUserFeedback = async (feedbackData) => {
  return AjaxUtils.post('/api/v1/user-activity/feedback', feedbackData);
};

export const submitContactsActivity = async ({ action, contacts }) => {
  return AjaxUtils.post('/api/v1/user-activity/contacts', { action, contacts });
};
